<template>
  <div class="consultas">
    <header class="view-header">
      <div class="view-header__text">
        <h1 class="view-header__title">Consultas</h1>
        <p class="view-header__sub">Las consultas recibidas desde tu sitio web y los portales.</p>
      </div>

      <!-- Lista ⇄ Tablero (the funnel board) -->
      <div class="consultas__viewseg">
        <button type="button" :class="{ on: view === 'list' }" @click="setView('list')">Lista</button>
        <button type="button" :class="{ on: view === 'board' }" @click="setView('board')">Tablero</button>
      </div>
    </header>

    <inquiry-board v-if="view === 'board'" :key="'board-' + reloadKey" @open-list="openListWithStatus" />

    <v-tabs
      v-if="view === 'list'"
      v-model="tab"
      color="primary"
      slider-color="accent"
      background-color="transparent"
      :grow="$vuetify.breakpoint.mobile"
      class="consultas__tabs"
      >
      <v-tab>Por propiedad</v-tab>
      <v-tab>General</v-tab>
      <v-tab>Inversión</v-tab>
    </v-tabs>

    <v-tabs-items
      v-if="view === 'list'"
      v-model="tab"
      :key="tab + '-' + reloadKey"
      class="consultas__items"
      >
      <v-tab-item>
        <inquiries-list :initial-status="listStatus"></inquiries-list>
      </v-tab-item>
      <v-tab-item>
        <inquiries-list type="global"></inquiries-list>
      </v-tab-item>
      <v-tab-item>
        <inquiries-list type="investments"></inquiries-list>
      </v-tab-item>
    </v-tabs-items>

    <!-- mobile create: a FAB opens the activator-less create dialog -->
    <create ref="create" no-activator @reload="reloadKey++"></create>

    <v-btn
      v-if="$vuetify.breakpoint.smAndDown"
      fab
      fixed
      bottom
      right
      color="accent"
      class="consultas__fab"
      aria-label="Nueva gestión"
      @click="$refs.create.open()"
      >
      <hero-icon :icon="PlusIcon" :size="24" />
    </v-btn>
  </div>
</template>

<script>
import InquiriesList from '@/components/inquiries/List'
import InquiryBoard from '@/components/inquiries/Board'
import Create from '@/components/inquiries/Create'
import HeroIcon from '@/components/shared/HeroIcon'
import PlusIcon from 'heroicons/24/outline/plus.svg'
import staffOnly from '@/mixins/staffOnly'

export default {
  mixins: [staffOnly],

  data: () => ({
    tab: 0,
    reloadKey: 0,
    view: localStorage.getItem('consultas_view') || 'list',
    listStatus: null,
    PlusIcon
  }),

  methods: {
    setView(v) {
      this.view = v
      if (v === 'board') this.listStatus = null
      try { localStorage.setItem('consultas_view', v) } catch (e) { /* private mode */ }
    },

    // "+N más" on a board column → the list, pre-filtered to that stage
    openListWithStatus(state) {
      this.listStatus = state
      this.tab = 0
      this.reloadKey++
      this.setView('list')
    }
  },

  components: {
    InquiriesList,
    InquiryBoard,
    Create,
    HeroIcon
  },
}
</script>

<style scoped>
/* layout (centering/cap/padding) comes from the global .app-content in App.vue */

/* reusable view header (matches the base — see Socials) */
.view-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

/* Lista ⇄ Tablero segmented toggle */
.consultas__viewseg {
  display: inline-flex;
  background: #fff;
  border: 1px solid #e7e2d9;
  border-radius: 10px;
  padding: 3px;
  gap: 2px;
}
.consultas__viewseg button {
  border: none;
  background: none;
  font-size: 12.5px;
  font-weight: 600;
  color: #6a645a;
  padding: 6px 14px;
  border-radius: 8px;
  cursor: pointer;
}
.consultas__viewseg button.on {
  background: #1a1814;
  color: #fff;
}
.view-header__title {
  font-size: 26px;
  font-weight: 700;
  line-height: 1.1;
  color: #1a1814;
  margin: 0;
}
.view-header__sub {
  font-size: 13.5px;
  color: #756f64;
  margin: 5px 0 0;
}

/* tabs: ink labels (normal case), brand-red slider */
.consultas__tabs >>> .v-tabs-bar {
  background: transparent;
  border-bottom: 1px solid #ece7de;
}
.consultas__tabs >>> .v-tab {
  text-transform: none;
  letter-spacing: normal;
  font-size: 14.5px;
  font-weight: 500;
}
.consultas__items {
  background: transparent;
  padding-top: 18px;
}

.consultas__fab { z-index: 6; }
.consultas__fab .hero-icon { color: #fff; }
</style>
